import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import PageLoader from '@shared/page-loader';
import AppBackground from '@shared/app-background';
import ConnectedAlert from '@shared/alert';
import LazyLoadComponent from '@scaffolding/lazy-component';

import ProgressHeader from '../../components/progress-header';
import styles from './reg-template.css';

class RegTemplate extends Component {
    componentDidMount() {
        const {
            profile,
            prospect,
            fetchProfile,
            route: { routeProps },
            getProspect,
            prospectId,
        } = this.props;

        const isFirstStep = routeProps.registrationStep === 1;

        if (isFirstStep && prospectId && prospect.isInitial) {
            getProspect(prospectId);
        }

        if (!isFirstStep && profile.isInitial) {
            fetchProfile();
        }
    }

    render() {
        const { profile, prospect, route, match, parentState, parentDispatch, coreAppBridgeTypes } = this.props;
        const { routeProps } = route;
        const { registrationStep, background = {} } = routeProps;
        const { market } = match.params;
        const backgroundProps = { ...background, overrideMarket: market };
        const isNotProspectComplete = registrationStep === 1 && !prospect.isComplete;
        const isNotProfileComplete = registrationStep !== 1 && !profile.isComplete;
        if (isNotProspectComplete || isNotProfileComplete)
            return (
                <div className={styles.loader} data-qa="reg-template-spinner">
                    <PageLoader />
                </div>
            );
        return (
            <Fragment>
                <AppBackground {...backgroundProps} />
                <ProgressHeader menu="registration" urlMarket={market} />

                <div className={styles.alertContainer}>
                    <ConnectedAlert dataQa="reg-template-alert" />
                </div>

                <div className={styles.contentWrapper}>
                    <LazyLoadComponent
                        component={{
                            ...route,
                            computedMatch: match,
                            parentProps: {
                                initialState: parentState,
                                dispatch: parentDispatch,
                                coreAppBridgeTypes,
                            },
                        }}
                    />
                </div>
            </Fragment>
        );
    }
}

RegTemplate.propTypes = {
    profile: PropTypes.object.isRequired,
    fetchProfile: PropTypes.func.isRequired,
    prospect: PropTypes.object.isRequired,
    getProspect: PropTypes.func.isRequired,
    prospectId: PropTypes.string.isRequired,
    route: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    parentState: PropTypes.object.isRequired,
    parentDispatch: PropTypes.func.isRequired,
    coreAppBridgeTypes: PropTypes.array.isRequired,
};

export default RegTemplate;
